<template>
  <v-container grid-list-md>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="400px"
      transition="dialog-transition"
    >
      <template v-slot:activator="{}">
        <v-btn fab :loading="loading" color="error" dark @click="onOpenExpense">
          <v-icon>fas fa-hands-helping</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-title>
          Daily Expense
          <v-spacer></v-spacer>
          <v-btn text icon @click.stop="close">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-form ref="form" v-model="valid" class="mx-5">
          <BaseDate
            :rules="v => !!v || 'Expense Date is required'"
            v-model="expense.date"
          ></BaseDate>
          <v-select
            outlined
            :loading="loading"
            v-model.trim="expense.expenseType"
            :rules="[v => !!v || 'Expense Type is required']"
            :items="expenseTypes"
            return-object
            item-text="AccountName"
            item-value="_id"
            label="Expense Type"
            prepend-inner-icon="fas fa-search-dollar"
            @click:prepend-inner="OnNewExpense"
            required
            no-data-text="Refresh the page"
          ></v-select>

          <BaseNumInput
            outlined
            label="Amount"
            :rules="[isGreaterthanZero]"
            v-model.number="expense.Amount"
          ></BaseNumInput>
          <v-text-field
            outlined
            v-model="expense.Details"
            :rules="[v => !!v || 'Details is required']"
            label="Details"
            prepend-inner-icon="fas fa-comment-dots"
            required
          >
          </v-text-field>
          <small class="text-center warning white--text d-block"
            >Note the expense amount is based on
            <strong class="black--text">{{ UsersToken.CashBase }}</strong>
          </small>
        </v-form>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            color="error"
            class=" white--text"
            width="200px"
            :loading="clicked"
            @click="OnSaveExpense"
          >
            SAVE
            <!-- <v-icon right>fas fa-plus</v-icon> -->
          </v-btn>
        </v-card-actions>
        <NewExpense
          :loadFunction="OnItemAdded"
          :AccountType="14"
          title="New Expense"
          @OnClosed="OpenExpense = false"
          :OpenNewExpense="OpenExpense"
        >
        </NewExpense>
        <p v-if="ErrorMsg" class="red--text d-flex mt-2 justify-center">
          {{ ErrorMsg }}
        </p>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    onFinshed: {
      type: Function,
      required: true,
    },
  },
  components: {
    NewExpense: () => import("@/components/util/NewAccount.vue"),
  },
  data() {
    return {
      ID: "",
      dialog: false,
      loading: false,
      clicked: false,
      OpenExpense: false,
      valid: true,
      date: null,
      expenseTypes: [],
      ErrorMsg: "",
      expense: {
        date: "",
        Details: null,
        expenseType: null,
        Amount: 0,
      },
    };
  },

  computed: {
    ...mapGetters(["UsersToken"]),
  },

  methods: {
    close() {
      // console.log("colosed");
      this.dialog = false;
      this.expense.Details = null;
      this.expense.expenseType = null;
      this.expense.Amount = 0;
      this.expense.date = "";

      this.$emit("input", false);

      this.$refs.form.resetValidation();
      // this.loadFunction();
    },

    GetReq(url = "/expense", query = {}) {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url,
        query,
      });
    },
    OnNewExpense() {
      this.OpenExpense = true;
    },
    OnItemAdded() {
      this.onOpenExpense(null, true);
    },
    onOpenExpense(e, newItem = false) {
      this.expense.date = this.Current().date;
      if (this.expenseTypes.length && !newItem) {
        this.dialog = true;
        // console.log(newItem);
        return;
      }
      // console.log(this.expenseTypes.length);
      this.loading = true;
      this.GetReq()
        .then(exp => {
          this.loading = false;

          // console.log(exp);
          this.expenseTypes = exp.data;
          this.dialog = true;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
      // console.log(this.UsersToken);
    },
    isGreaterthanZero(v) {
      return v.toString().replace(/,/g, "") > 0 || "Expense Amount is required";
    },

    OnSaveExpense() {
      try {
        if (this.$refs.form.validate()) {
          this.clicked = true;
          // console.log(this.expense);
          // this.expense.date = this.Current().date;
          this.$store
            .dispatch("INSERT_ONLY", {
              url: "/expense",
              data: this.expense,
            })
            .then(() => {
              // this.loadFunction();
              this.onFinshed();
              this.close();
              // this.$refs.form.reset();
              this.clicked = false;

              // console.log(result);
            })
            .catch(err => {
              this.clicked = false;
              // console.log(err.response);
              this.ErrorMsg = err && err.response && err.response.data;
            });
        }
      } catch (error) {
        console.log(error);
      }
      this.ErrorMsg = "";
    },
  },
  created() {
    this.onOpenExpense();
  },
};
</script>
